import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadOrders from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import CardList, { CardListStyles } from "@insite/content-library/Components/CardList";
import { OrderSummaryCardStyles } from "@insite/content-library/Components/OrderSummaryCard";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import OrderSummaryCardMobile from "@WhiteCap/Components/OrderSummaryCardMobile";
// eslint-disable-next-line spire/fenced-imports
import loadOrdersStatus from "@WhiteCap/Handlers/OrderHistory/LoadOrdersStatus";
import CardListHeading from "@WhiteCap/Overrides/Components/CardListHeading";
import OrderSummaryCard from "@WhiteCap/Overrides/Components/OrderSummaryCard";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import * as cssLinter from "css";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    numberOfRecords = "numberOfRecords",
    customCSS = "customCSS",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfRecords]: number;
        [fields.customCSS]: string;
    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = session.isAuthenticated && !session.isGuest;
    const customSettings = state.context.settings.properties;
    return {
        ordersDataView: getOrdersDataView(state, recentOrdersParameter),
        orderHistoryPageLink: getPageLinkByPageType(state, "OrderHistoryPage"),
        settingsCollection: getSettingsCollection(state),
        canViewOrders: isAuthenticated && (session.userRoles || "").indexOf("Requisitioner") === -1,
        orderListData: state.WhiteCap.orderStatus.OrderData?.erpOrders,
        ordersDataViewLoading:getOrdersDataView(state, recentOrdersParameter).isLoading,
        userRoles: state.context.session.userRoles,
        customBuyerRoleName: customSettings?.customBuyerRoleName || "",
    };
};

const mapDispatchToProps = {
    loadOrders,
    loadOrdersStatus,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RecentOrdersStyles {
    cardList?: CardListStyles;
    errorGridItem?: GridItemProps;
    errorText?: TypographyPresentationProps;
    noOrdersFoundGridItem?: GridItemProps;
    noOrdersFoundText?: TypographyPresentationProps;
    cardContainer?: CardContainerStyles;
    orderSummaryCard?: OrderSummaryCardStyles;
    dataTable?: DataTableProps;
}

export const recentOrdersStyles: RecentOrdersStyles = {
    errorGridItem: { width: 12 },
    noOrdersFoundGridItem: { width: 12 },
    dataTable: {},
};

const defaultCustomCss = `.card-list-heading{
}

.view-all-link{
}

.no-orders-found-grid-item{
}

.description-grid-item{
}

.no-orders-found-text{
}

.card_container__wrapper{
    
}

.order-summary-card-grid-item{
}

.order-summary-card-container{
}

.page-type-link-grid-item{
}

.order-number-grid-item{
}

.status-grid-item{
}

.web-order-number-grid-item{
}

.total-grid-item{
}`;

let recentOrdersParameter: GetOrdersApiParameter = {
    customerSequence: "-1",
    page: 1,
    sort: "OrderDate DESC",
};

const styles = recentOrdersStyles;

class RecentOrders extends React.Component<Props> {
    componentDidMount() {
        recentOrdersParameter.pageSize = this.props.fields.numberOfRecords;
        if (this.props.canViewOrders) {
            this.props.loadOrders(recentOrdersParameter);
        }
    }
    // componentDidUpdate(prevProps: Props): void {
    //     if (this.props.ordersDataView.value !== prevProps.ordersDataView.value) {
    //         if (this.props.ordersDataView.value) {
    //             const orderStatusData = this.props.ordersDataView.value.map(order => order.properties.orderId);
    //             const orderNumbers: string[] = orderStatusData;
    //             this.props.loadOrdersStatus({ orderNumber: orderNumbers });
    //         }
    //     }
    //     if (this.props.orderListData !== prevProps.orderListData) {
    //         if (this.props.orderListData) {
    //             this.props.orderListData.forEach(erpOrderB => {
    //                 let correspondingOrderA: OrderModel | undefined;

    //                 if (this.props.ordersDataView.value) {
    //                     correspondingOrderA = this.props.ordersDataView.value.find(
    //                         orderA => orderA.erpOrderNumber === erpOrderB.erpOrderNumber,
    //                     );
    //                 }
    //                 console.log("correspondingOrderA", correspondingOrderA);
    //                 if (correspondingOrderA) {
    //                     correspondingOrderA.properties.shipViaDescription = erpOrderB.shipViaDescription;
    //                     // correspondingOrderA.properties = {
    //                     //     shipViaDescription: erpOrderB.shipViaDescription,
    //                     //     trackingURLs:erpOrderB.trackingURLs.length > 0 ? erpOrderB.trackingURLs[0] : "",
    //                     //     orderLinesCount: erpOrderB.orderLinesCount.toString(),
    //                     //     status: erpOrderB.status[0],
    //                     // };
    //                 }
    //             });
    //         }
    //     }
    //     // eslint-disable-next-line no-console
    //     console.log("ordersDataView.value", this.props.ordersDataView);
    // }

    render() {
        const { ordersDataView, orderHistoryPageLink, settingsCollection, canViewOrders, orderListData, ordersDataViewLoading, userRoles, customBuyerRoleName } = this.props;

        //EC-1598 Hide recent order for user with custom role
        if (userRoles?.toLowerCase().includes(customBuyerRoleName?.toLowerCase() || "")) {
            return null;
        }

        if(ordersDataViewLoading){
            return <LoadingSpinner css={css`display: flex;margin: auto;`} />;
        }

        if (!canViewOrders || !ordersDataView.value) {
            return null;
        }
        
        const orderHistoryUrl = orderHistoryPageLink ? orderHistoryPageLink.url : undefined;

        const customCssWrapper = {
            css: css`
                ${this.props.fields.customCSS}
            `,
        };

        return (
            <StyledWrapper {...customCssWrapper}>
                <CardList
                    css={css`
                        padding-bottom: 50px;
                    `}
                    extendedStyles={styles.cardList}
                    data-test-selector="widget_RecentOrders"
                >
                    <CardListHeading
                        heading={translate(`Recent Orders (${ordersDataView.value.length})`)}
                        viewAllUrl={orderHistoryUrl}
                    />
                    {ordersDataView.value.length === 0 && (
                        <GridItem className="no-orders-found-grid-item" {...styles.noOrdersFoundGridItem}>
                            <Typography
                                className="no-orders-found-text"
                                {...styles.noOrdersFoundText}
                                data-test-selector="recentOrders_NoOrdersFound"
                            >
                                {translate("No orders found")}
                            </Typography>
                        </GridItem>
                    )}
                    <Hidden
                        above="sm"
                        css={css`
                            width: 100%;
                            table {
                                border-collapse: collapse;
                                border-spacing: 0 10px;
                            }
                            tr {
                                border-top: 1px solid ${getColor("common.border")};
                            }
                        `}
                    >
                    <GridItem width={12} css={css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`   `,
                css`
                padding-left: 20px;
    padding-right: 20px;
                `,
                css`
                padding-left: 20px;
    padding-right: 20px;
                `,
                css`padding-right: 20px;`,
                css``,
            ])}
            &&& {
                        width: 100%;
                        overflow-x: auto;
                    }
            `}>
                        <DataTable {...styles.dataTable}>
                            <DataTableBody data-test-selector="orderHistoryTable_tableBody">
                                {ordersDataView.value.map(
                                    (order, index) =>
                                        order !== null && (
                                            // eslint-disable-next-line react/jsx-key
                                            <OrderSummaryCardMobile
                                                order={order}
                                                indexNumber={index}
                                                orderSettings={settingsCollection.orderSettings}
                                                extendedStyles={styles.orderSummaryCard}
                                            />
                                        ),
                                )}
                            </DataTableBody>
                        </DataTable>
                        </GridItem>
                    </Hidden>
                    <Hidden
                        below="md"
                        css={css`
                            width: 100%;
                        `}
                    >
                        <DataTable {...styles.dataTable}>
                            <DataTableBody data-test-selector="orderHistoryTable_tableBody">
                                {ordersDataView.value.map(
                                    (order, index) =>
                                        order !== null && (
                                            // eslint-disable-next-line react/jsx-key
                                            <OrderSummaryCard
                                                order={order}
                                                indexNumber={index}
                                                orderSettings={settingsCollection.orderSettings}
                                                extendedStyles={styles.orderSummaryCard}
                                            />
                                        ),
                                )}
                            </DataTableBody>
                        </DataTable>

                    </Hidden>
                </CardList>
                </StyledWrapper>
        );
    }
}

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RecentOrders),
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.numberOfRecords,
                displayName: "Number of Recent Orders Displayed",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 5,
                fieldType: "General",
                sortOrder: 1,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
